/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import {
  ListDevicesActions,
  ListDevicesActionTypes,
  listDevicesFailed,
  ListDevicesRequest,
  listDevicesSucceeded,
} from './action';
import { LIST_DEVICES_QUERY } from './listDevicesQuery';

export function listDevicesEpic(action$): Observable<ListDevicesActions> {
  return action$.pipe(
    filter((action: ListDevicesActions) => action.type === ListDevicesActionTypes.LIST_DEVICES_REQUEST),
    switchMap(({ input }: ListDevicesRequest) =>
      listDevices({ input }).then(listDevicesSucceeded).catch(listDevicesFailed),
    ),
  );
}

export async function listDevices({ input }) {
  console.log('📦  ListDeviceInput:', JSON.stringify(input, null, 2));
  const graphQLClient = await setAuthenticatedClient();
  console.log('📦 GraphQL Client:', graphQLClient ? 'OK' : 'NULL');

  try {
    const {
      data: {
        listDevices: { total, devices },
      },
    } = await graphQLClient.query({
      query: LIST_DEVICES_QUERY,
      variables: { input },
    });
    console.log('📦  ListDeviceRequest:', JSON.stringify(devices, null, 2));

    console.log('ListData:', devices, total);
    return { total, devices };
  } catch (e) {
    throw new Error('Failed to create device');
  }
}
